const overlay = document.getElementById('falconPopupOverlay');
const closeButton = document.getElementById('falconPopupClose');
const declineButton = document.getElementById('falconPopupDecline');

if (overlay && closeButton && declineButton) {
	function openPopup() {
		overlay.classList.remove('is-hidden');
		overlay.setAttribute('aria-hidden', 'false');
		closeButton.focus();
	}

	function closePopup() {
		overlay.classList.add('is-hidden');
		overlay.setAttribute('aria-hidden', 'true');
	}

	closeButton.addEventListener('click', closePopup);
	declineButton.addEventListener('click', closePopup);

	openPopup();
}
